var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "create-package bg-white"
  }, [_c('div', {
    staticClass: "flex justify-between items-stretch shadow-border-b mdmax:flex-col"
  }, [_c('div', {
    staticClass: "flex-1 shadow-border-r p-6 mdmax:shadow-border-b mdmax:flex-auto mdmax:w-full"
  }, [_c('p', {
    staticClass: "font-bold text-lg mb-6"
  }, [_vm._v(_vm._s(_vm.isEditMode ? 'Edit' : 'Buat') + " Layanan")]), _c('div', {
    staticClass: "mb-6"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "label": "Nama Layanan",
      "placeholder": "Masukan nama layanan"
    },
    model: {
      value: _vm.name,
      callback: function ($$v) {
        _vm.name = $$v;
      },
      expression: "name"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "label": "Kode Layanan (Sistem saat ini)",
      "placeholder": "Masukan kode layanan"
    },
    model: {
      value: _vm.serviceCode,
      callback: function ($$v) {
        _vm.serviceCode = $$v;
      },
      expression: "serviceCode"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Deskripsi")]), _c('quill-editor', {
    ref: "myQuillEditor1",
    attrs: {
      "options": _vm.option
    },
    model: {
      value: _vm.description,
      callback: function ($$v) {
        _vm.description = $$v;
      },
      expression: "description"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Tipe Layanan")]), _c('CustomSelect', {
    attrs: {
      "options": _vm.deliveryServiceTypeList,
      "default": _vm.deliveryServiceType,
      "placeholder": "Pilih tipe layanan",
      "optionLabel": "name"
    },
    model: {
      value: _vm.deliveryServiceType,
      callback: function ($$v) {
        _vm.deliveryServiceType = $$v;
      },
      expression: "deliveryServiceType"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Kategori Layanan")]), _c('CustomSelect', {
    attrs: {
      "options": _vm.serviceCategory,
      "default": _vm.selectedServiceCategory,
      "placeholder": "Pilih kategori layanan",
      "optionLabel": "name"
    },
    model: {
      value: _vm.selectedServiceCategory,
      callback: function ($$v) {
        _vm.selectedServiceCategory = $$v;
      },
      expression: "selectedServiceCategory"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Cost Mapping")]), _c('CustomSelect', {
    attrs: {
      "options": _vm.costMapping,
      "default": _vm.selectedCostMapping,
      "placeholder": "Pilih cost mapping",
      "optionLabel": "name",
      "enableSearch": ""
    },
    on: {
      "search": _vm.doSearch
    },
    model: {
      value: _vm.selectedCostMapping,
      callback: function ($$v) {
        _vm.selectedCostMapping = $$v;
      },
      expression: "selectedCostMapping"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Syarat & Ketentuan")]), _c('quill-editor', {
    ref: "myQuillEditor2",
    attrs: {
      "options": _vm.option
    },
    model: {
      value: _vm.termAndCondition,
      callback: function ($$v) {
        _vm.termAndCondition = $$v;
      },
      expression: "termAndCondition"
    }
  })], 1)]), _c('div', {
    staticClass: "flex-1 mdmax:flex-auto mdmax:w-full"
  }, [_c('div', {
    staticClass: "p-6"
  }, [_c('div', {
    staticClass: "mb-6"
  }, [_c('p', {
    staticClass: "font-bold text-lg mb-6"
  }, [_vm._v("Kategori Barang")]), _vm._l(_vm.goodsCategories, function (goods, index) {
    return _c('div', {
      key: 'goods' + index,
      staticClass: "mb-3"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.selectedGoodsCategories,
        expression: "selectedGoodsCategories"
      }],
      staticClass: "styled-checkbox",
      attrs: {
        "type": "checkbox",
        "name": "goodsCategory",
        "id": goods.code
      },
      domProps: {
        "value": goods.code,
        "checked": Array.isArray(_vm.selectedGoodsCategories) ? _vm._i(_vm.selectedGoodsCategories, goods.code) > -1 : _vm.selectedGoodsCategories
      },
      on: {
        "change": function ($event) {
          var $$a = _vm.selectedGoodsCategories,
              $$el = $event.target,
              $$c = $$el.checked ? true : false;

          if (Array.isArray($$a)) {
            var $$v = goods.code,
                $$i = _vm._i($$a, $$v);

            if ($$el.checked) {
              $$i < 0 && (_vm.selectedGoodsCategories = $$a.concat([$$v]));
            } else {
              $$i > -1 && (_vm.selectedGoodsCategories = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
            }
          } else {
            _vm.selectedGoodsCategories = $$c;
          }
        }
      }
    }), _c('label', {
      attrs: {
        "for": goods.code
      }
    }, [_vm._v(_vm._s(goods.name))])]);
  })], 2), _c('p', {
    staticClass: "font-bold text-lg mb-6"
  }, [_vm._v("Status Layanan")]), _c('div', {
    staticClass: "flex items-center gap-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 block"
  }, [_vm._v("Status")]), _c('label', {
    staticClass: "relative inline-block h-4 leading-0"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.status,
      expression: "status"
    }],
    staticClass: "w-10 h-4 transition bg-gray-300 rounded-full shadow-inner outline-none appearance-none checked:bg-blue-500 disabled:bg-gray-100",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.status) ? _vm._i(_vm.status, null) > -1 : _vm.status
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.status,
            $$el = $event.target,
            $$c = $$el.checked ? true : false;

        if (Array.isArray($$a)) {
          var $$v = null,
              $$i = _vm._i($$a, $$v);

          if ($$el.checked) {
            $$i < 0 && (_vm.status = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.status = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.status = $$c;
        }
      }
    }
  }), _c('span', {
    staticClass: "absolute top-0 left-0 w-4 h-4 transition-all transform scale-150 bg-system-gray rounded-full shadow-sm cursor-pointer"
  })]), _c('p', {
    class: [_vm.status ? 'text-system-success' : 'text-system-error']
  }, [_vm._v(_vm._s(_vm.status ? 'Active' : 'In Active'))])])])])]), _c('div', {
    staticClass: "flex justify-end gap-6 p-6"
  }, [_c('Button', {
    attrs: {
      "buttonText": _vm.isEditMode ? 'Update' : 'Simpan',
      "type": "primary",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function ($event) {
        return _vm.save();
      }
    }
  })], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }